// ABOUTME: Pure helpers for the TikTok Shop OAuth flow: picking a shop from the
// ABOUTME: callback payload and flattening it into the stored credentials blob.

// The callback payload nests authorized shops in a shops[] array; a single shop is
// auto-selected, multiple shops require the caller to show a picker (returns null).
// A preferred shop id that no longer matches (e.g. the seller switched shops before
// reconnecting) falls back to the single-shop auto-select rather than failing.
export const pickTikTokShop = (shops, preferredShopId) => {
    if (!Array.isArray(shops) || shops.length === 0) return null;
    if (preferredShopId) {
        const match = shops.find(shop => shop.shop_id === preferredShopId);
        if (match) return match;
    }
    return shops.length === 1 ? shops[0] : null;
};

// The backend precomputes expiresAt from TikTok's expiry; without it (or without
// tokens) the connection attempt is treated as failed rather than storing a
// malformed credentials blob.
export const buildTikTokCredentials = (payload, shop) => {
    if (!payload || !shop) return null;
    if (!payload.access_token || !payload.refresh_token || !payload.expiresAt) return null;
    // Every signed API call needs the shop cipher; a shop without one can never
    // produce a working connection, so refuse to build the blob.
    if (!shop.shop_cipher) return null;
    return {
        access_token: payload.access_token,
        refresh_token: payload.refresh_token,
        expiresAt: payload.expiresAt,
        shop_cipher: shop.shop_cipher,
        shop_id: shop.shop_id,
        seller_name: payload.seller_name,
        // A missing region must not overwrite the stored value with undefined,
        // which would be dropped from the JSON blob posted to the backend.
        region: payload.region || shop.region || 'global',
    };
};
